module.exports = __webpack_public_path__ + "static/assets/4f7d00f4a512a3d92bdf8b4a620165b2.png";